export const LOGO_URL = "https://customer-assets.emergentagent.com/job_3f6aeb0f-8e60-46a8-8f7a-3fc15749da5c/artifacts/11ug0vp8_cropped-HostMarket-nuovo.png";

export const HERO_IMAGES = [
  "https://static.prod-images.emergentagent.com/jobs/3f6aeb0f-8e60-46a8-8f7a-3fc15749da5c/images/5422b37e4e3d5d76d2ceb81f441b46745da2ea38c9e1286111ffe8166f64a0f2.png",
  "https://static.prod-images.emergentagent.com/jobs/3f6aeb0f-8e60-46a8-8f7a-3fc15749da5c/images/080898be3d54160b42282f83e0013177fb635beb587ed5556d8068cdb0ddaeea.png",
];

export const ACCENT_IMAGES = [
  "https://images.pexels.com/photos/32932347/pexels-photo-32932347.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.pexels.com/photos/31397881/pexels-photo-31397881.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.pexels.com/photos/8353836/pexels-photo-8353836.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.pexels.com/photos/8729937/pexels-photo-8729937.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
];

export const CATEGORY_ICON = {
  "accoglienza-checkin": "fa-key",
  "architetti": "fa-drafting-compass",
  "artisti-artigiani": "fa-palette",
  "assicurazioni": "fa-shield-halved",
  "avvocati": "fa-scale-balanced",
  "commercialisti": "fa-calculator",
  "elettricista": "fa-bolt",
  "fotografi": "fa-camera",
  "homestager": "fa-couch",
  "idraulico": "fa-wrench",
  "imprese-pulizie": "fa-broom",
  "lavanderie": "fa-soap",
  "property-manager": "fa-building",
  "revenue-manager": "fa-chart-line",
  "servizi-digitali": "fa-laptop-code",
  "social-media-manager": "fa-hashtag",
  "specialisti-affitti-brevi": "fa-suitcase-rolling",
  "web-designer": "fa-pen-ruler",
};

export const TIER_COLORS = {
  basic: "#A1A1AA",
  standard: "#FFBE00",
  premium: "#E619A8",
};

export const TIER_LABEL = {
  basic: "Basic",
  standard: "Standard",
  premium: "Premium",
};
